/**
 * Club signup, wherever it appears.
 *
 * Wires any [data-club-form] on the page: validates an Israeli mobile number,
 * insists on explicit SMS consent, and posts the subscriber to Klaviyo — the
 * SMS platform already installed on this store.
 *
 * Without a list id Klaviyo cannot record consent, so the form says so plainly
 * rather than showing a success message for something that did not happen.
 */

/** Israeli mobile numbers, typed the way people actually type them. */
function toE164(raw) {
  const digits = String(raw).replace(/[^\d+]/g, '');
  if (/^\+972\d{8,9}$/.test(digits)) return digits;
  if (/^972\d{8,9}$/.test(digits)) return `+${digits}`;
  if (/^0\d{8,9}$/.test(digits)) return `+972${digits.slice(1)}`;
  return null;
}

function wire(form) {
  const status = form.querySelector('[data-club-status]');
  const company = form.dataset.klaviyoCompany;
  const list = form.dataset.klaviyoList;

  const say = (message, kind) => {
    if (!status) return;
    status.textContent = message;
    status.dataset.kind = kind;
  };

  form.addEventListener('submit', async (event) => {
    event.preventDefault();

    const nameInput = form.querySelector('input[name="name"]');
    const phoneInput = form.querySelector('input[name="phone"]');
    const consent = form.querySelector('input[name="consent"]');
    const button = form.querySelector('button[type="submit"]');

    const fullName = (nameInput?.value ?? '').trim();
    if (nameInput && fullName.length < 2) {
      say('נא להזין שם מלא', 'error');
      nameInput.focus();
      return;
    }

    const phone = toE164(phoneInput?.value ?? '');
    if (!phone) {
      say('נא להזין מספר טלפון נייד תקין', 'error');
      phoneInput?.focus();
      return;
    }
    if (!consent?.checked) {
      say('צריך לאשר קבלת הודעות כדי להצטרף', 'error');
      return;
    }
    if (!company || !list) {
      say('ההרשמה עדיין לא מחוברת. נא להשלים את מזהה הרשימה בקלביו.', 'error');
      return;
    }

    button?.setAttribute('disabled', '');
    say('רק רגע...', 'pending');

    try {
      const response = await fetch(
        `https://a.klaviyo.com/client/subscriptions/?company_id=${encodeURIComponent(company)}`,
        {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', revision: '2024-10-15' },
          body: JSON.stringify({
            data: {
              type: 'subscription',
              attributes: {
                profile: {
                  data: {
                    type: 'profile',
                    attributes: {
                      phone_number: phone,
                      first_name: fullName.split(/\s+/)[0] || undefined,
                      last_name: fullName.split(/\s+/).slice(1).join(' ') || undefined,
                      subscriptions: { sms: { marketing: { consent: 'SUBSCRIBED' } } },
                    },
                  },
                },
              },
              relationships: { list: { data: { type: 'list', id: list } } },
            },
          }),
        }
      );
      if (!response.ok) throw new Error(String(response.status));
      say('הצטרפת למועדון. קוד ההנחה בדרך אליך בהודעה.', 'success');
      form.querySelector('.club-form__input--name')?.setAttribute('hidden', '');
      form.querySelector('.club-form__row')?.setAttribute('hidden', '');
      form.querySelector('.club-form__consent')?.setAttribute('hidden', '');
    } catch {
      say('משהו השתבש. אפשר לנסות שוב בעוד רגע.', 'error');
      button?.removeAttribute('disabled');
    }
  });
}

document.querySelectorAll('[data-club-form]').forEach(wire);
